import React from "react";
import classnames from "classnames";
import groupBy from "lodash/groupBy";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";

import FormHelper from "../form.js";
import auth from "store/tenant/auth.js";
import Lib from "utils/Lib";

/*import FormHelperLocation from '../../../location/helper/form.js';*/
import {
  ButtonValidation,
  ButtonCancel
} from "../../../../component/Button.js";
import SelectQuery from "../../../../component/SelectQuery.js";
import ModalSelectInMap from "../../../../utils/Modal/ModalSelectInMap.js";
import Module from "../../../../utils/Render.js";
import Request from "../../../../config/Request.js";

export default class ModalSite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alias: "",
      name: "",
      tag: "",
      description: "",
      type: "",
      address: "",
      address2: "",
      latitude: "",
      longitude: "",
      gmaps_url: "",
      city: "",
      gstreet_url: "",
      postal_code: "",
      project_name: "",
      contact: "",
      status: "",
      location: {
        name: "",
        description: "",
        contact: "",
        site: "samsuled"
      },
      locationRow: null,
      overflowAddLocation: "hidden",
      is_process: false,
      modalMap: false,
      toggleAddLocation: false
    };

    this.tempLocation = [];
    this.modalAction = this.modalAction.bind(this);
    this.toggleModalSelectInMap = this.toggleModalSelectInMap.bind(this);

    this.onRegister = this.onRegister.bind(this);
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this);
    this.onRegisterFailed = this.onRegisterFailed.bind(this);

    this.onUpdate = this.onUpdate.bind(this);
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
    this.onUpdateFailed = this.onUpdateFailed.bind(this);

      this.is_lite = false
    
  }

  // Get Data from google map
  toggleModalSelectInMap() {
    this.setState({ modalMap: !this.state.modalMap });
  }

  getMapLocation(data) {
    this.setState({
      address: data.address,
      address2: data.address2,
      postal_code: data.postal,
      latitude: data.latitude.toString(),
      longitude: data.longitude.toString(),
      gmaps_url: data.mapURL,
      gstreet_url: data.streetViewURL
    });
  }

  modalAction() {
    const { mode } = this.props;
    if (!FormHelper.ValidateForm(this.state,this.is_lite)) {
      return;
    }

    let data = {
      alias: this.state.alias,
      name: this.state.name,
      tag: this.state.tag,
      description: this.state.description,
      type: this.state.type,
      address: this.state.address,
      address2: this.state.address2,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      gmaps_url: this.state.gmaps_url,
      city: this.state.city,
      gstreet_url: this.state.gstreet_url,
      postal_code: this.state.postal_code,
      project_name: this.state.project_name,
      contact: this.state.contact,
      status: this.state.status
    };

    if (mode === "modal_add") {
      this.onRegister(data);
    } else {
      this.onUpdate(data);
    }
  }

  // ==================== Register
  async onRegister(data) {
    const {state} = this
    if(this.is_lite){
    const type = await Request(
      "get",
      "read-site-type-autocomplete", 
      {},
      {search:""},
      [],
      ()=>null,
      ()=>null,
      undefined,
      null
    );
    const contact = await Request(
      "get",
      "read-contact-autocomplete", 
      {},
      {search:""},
      [],
      ()=>null,
      ()=>null,
      undefined,
      null
    );
   if(type === null || contact === null){
    this.onRegisterFailed()
  }
  data.contact = contact.results[0].Alias
  data.type = type.results[0].Alias
  }
    let payload = {
      Alias: data.alias,
      Name: data.name,
      Tag: data.tag,
      Description: data.description,
      Type: data.type,
      Address: data.address,
      Address2: data.address2,
      Latitude: data.latitude,
      Longitude: data.longitude,
      GoogleMapURL: data.gmaps_url,
      City: data.city,
      GoogleStreetviewURL: data.gstreet_url,
      Postal: data.postal_code,
      ProjectName: data.project_name,
      Contact: data.contact,
      Status: data.status
    };
    Request(
      "post",
      "register-site",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      payload,
      [],
      this.onRegisterSuccess,
      this.onRegisterFailed
    );

    this.setState({ is_process: true });
  }

  onRegisterSuccess(response) {
    // if(response.data.IsReminder === "Yes") {
    for (let i = 0; i < this.tempLocation.length; i++) {
      this.onRegisterLocation(this.tempLocation[i], response.data.Alias);
    }
    // }
    toast.success("Register Site success");
    this.setState({ is_process: false });
    this.props.close();
    this.props.onSuccess();
  }

  onRegisterFailed(error) {
    this.setState({ is_process: false });
    this.props.onFailed(error);
  }

  // ==================== Update
  onUpdate(data) {
    this.setState({ is_process: true }, async () => {
      const tenantCredential = auth.GetCredential();

      if (data.status === tenantCredential.in_active_site_status.Alias) {
        const assets = await Request(
          "get",
          "improved-read-asset",
          {
            Authorization: "Bearer " + this.props.UserReducer.token
          },
          { use_pagination: false, site: data.alias },
          [],
          undefined,
          this.onUpdateFailed,
          undefined,
          null
        );

        if (!assets) return;
        else if (!!assets.length) {
          const groupedAssets = groupBy(assets, "Location");

          await Lib.confirm({
            rejectable: false,
            title:
              "Can't set Site to " +
              tenantCredential.in_active_site_status.Name,
            content: (
              <div className="row">
                <div className="col-md-12">
                  Please move assets in these following locations:
                  <ul>
                    {Object.keys(groupedAssets).map(l => (
                      <li>
                        <strong>{l}</strong> ({groupedAssets[l].length} assets)
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )
          });

          this.onUpdateFailed({
            response: { data: "must move assets on locations!" }
          });
          return;
        }
      }

      let payload = {
        Alias: data.alias,
        Name: data.name,
        Tag: data.tag,
        Description: data.description,
        Type: data.type,
        Address: data.address,
        Address2: data.address2,
        Latitude: data.latitude,
        Longitude: data.longitude,
        GoogleMapURL: data.gmaps_url,
        City: data.city,
        GoogleStreetviewURL: data.gstreet_url,
        Postal: data.postal_code,
        ProjectName: data.project_name,
        Contact: data.contact,
        Status: data.status
      };

      Request(
        "put",
        "update-site",
        { Authorization: "Bearer " + this.props.UserReducer.token },
        payload,
        [data.alias],
        this.onUpdateSuccess,
        this.onUpdateFailed
      );
    });
  }

  onUpdateSuccess(response) {
    toast.success("Update Site success");
    this.setState({ is_process: false });
    this.props.close();
    this.props.onSuccess();
  }

  onUpdateFailed(error) {
    this.setState({ is_process: false });
    Lib.responseMessage("error", error.response.data);
    // this.props.onFailed(error);
  }

  addToLocationList() {
    const { location } = this.state;

    if (!FormHelper.ValidateFormLocation(this.state.location,this.is_lite)) {
      return;
    }

    let locationItems = {
      name: location.name,
      description: location.description,
      contact: location.contact
    };

    this.tempLocation.unshift(locationItems);

    this.setState({
      locationRow: this.generateLocationList(this.tempLocation),
      // overflowAddLocation : 'auto',
      location: {
        name: "",
        description: "",
        contact: "",
        site: "samsuled"
      }
    });

    toast.success("Add Location Success");
  }

  removeLocationFromList(index) {
    this.tempLocation.splice(index, 1);
    this.setState({
      locationRow: this.generateLocationList(this.tempLocation)
    });
  }

  generateLocationList(data) {
    const el = data.map((val, index) => {
      return (
        <tr key={index}>
          <td>{val.name}</td>
          <td>{val.description}</td>
          {!this.is_lite &&(
          <td>{val.contact.Name}</td>
          )}
          <td className="text-center">
            <button
              className="btn btn-link apple-red"
              onClick={() => this.removeLocationFromList(index)}
            >
              <i className="icon-trash" />
            </button>
          </td>
        </tr>
      );
    });
    return el;
  }

  renderLocationField() {
    if (this.props.mode === "modal_add") {
      return (
        <div className="row">
          <div className="form-group col-sm-12">
            <div>
              <div className="list-separator">
                <div className="float-right">
                  <button
                    type="button"
                    style={{ fontSize: 12 }}
                    className="btn btn-sm btn-primary"
                    onClick={() =>
                      this.setState({
                        toggleAddLocation: !this.state.toggleAddLocation
                      })
                    }
                  >
                    <i className="fa fa-dot-circle-o"></i> Add New Location
                  </button>
                </div>
                <div className="item-inner">Location</div>
              </div>
            </div>
          </div>
          <div
            className={classnames("isRepeatBox", {
              open: this.state.toggleAddLocation
            })}
            style={{ overflowY: this.state.overflowReminder }}
          >
            <div className="row">
              <div
                className="form-group col-sm-6"
                style={{ paddingTop: "13px" }}
              >
                <label className="required">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type Name"
                  value={this.state.location.name}
                  onChange={e =>
                    this.setState({
                      location: { ...this.state.location, name: e.target.value }
                    })
                  }
                />
              </div>
              {!this.is_lite &&(
              <div
                className="form-group col-sm-6"
                style={{ paddingTop: "13px" }}
              >
                <label className="required">Contact</label>
                <SelectQuery
                  placeholder="Type Contact"
                  value={this.state.location.contact}
                  onChange={e =>
                    this.setState({
                      location: { ...this.state.location, contact: e }
                    })
                  }
                  urlKey="read-contact-autocomplete"
                  valKey="Alias"
                  valLabel="Name"
                  isCreatable={false}
                  UserReducer={this.props.UserReducer}
                />
              </div>
              )}
              <div className="form-group col-sm-12">
                <label className="required">Description</label>
                <textarea
                  rows="5"
                  className="form-control"
                  placeholder="Enter Location Description"
                  value={this.state.location.description}
                  onChange={e =>
                    this.setState({
                      location: {
                        ...this.state.location,
                        description: e.target.value
                      }
                    })
                  }
                />
              </div>
              <div className="col-sm-12 list-separator">
                <div className="text-center">
                  <button
                    type="button"
                    onClick={() => this.addToLocationList()}
                    className="btn btn-sm btn-primary"
                  >
                    <i className="icon-arrow-down-circle"></i>&nbsp;&nbsp;Add to
                    list
                  </button>
                </div>
                <div className="item-inner">Location List</div>
              </div>
            </div>
            <table className="table table-striped table-responsive m-top-15 table">
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Description</th>
                  {!this.is_lite && (
                  <th>Contact</th>
                  )}
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{this.state.locationRow}</tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  async onRegisterLocation(data, siteAlias) {
    let payload = {
      Name: data.name,
      Description: data.description,
      ContactAlias: data.contact.Alias,
      SiteAlias: siteAlias
    };
    if(this.is_lite){
    const contact = await Request(
      "get",
      "read-contact-autocomplete", 
      {},
      {search:""},
      [],
      ()=>null,
      ()=>null,
      undefined,
      null
    )
    if(contact === null){
      this.onRegisterLocationFailed
      return
    }
    payload.ContactAlias = contact.results[0].Alias
    }
    Request(
      "post",
      "register-location",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      payload,
      [],
      () => undefined,
      this.onRegisterLocationFailed
    );

    this.setState({ is_process: true });
  }

  onRegisterLocationFailed(err) {}

  componentWillReceiveProps(nextProps) {
    let new_state = {};
    if (nextProps.mode === "modal_update") {
      new_state = {
        alias: nextProps.data.alias,
        name: nextProps.data.name,
        tag: nextProps.data.tag,
        description: nextProps.data.description,
        type: nextProps.data.type.Alias,
        address: nextProps.data.address,
        address2: nextProps.data.address2,
        latitude: nextProps.data.latitude,
        longitude: nextProps.data.longitude,
        gmaps_url: nextProps.data.gmaps_url,
        city: nextProps.data.city.pk,
        gstreet_url: nextProps.data.gstreet_url,
        postal_code: nextProps.data.postal_code,
        project_name: nextProps.data.project_name,
        contact: nextProps.data.contact.Alias,
        status: nextProps.data.status.Alias
      };
    } else {
      new_state = {
        alias: "",
        name: "",
        tag: "",
        description: "",
        type: "",
        address: "",
        address2: "",
        latitude: "",
        longitude: "",
        gmaps_url: "",
        city: "",
        gstreet_url: "",
        postal_code: "",
        project_name: "",
        contact: "",
        status: ""
      };
    }
    this.setState(new_state);
  }

  render() {
    const { isModal, close, mode } = this.props;
    this.is_lite = this.props.UserReducer.props.is_lite
    return (
      <Modal isOpen={isModal} toggle={close} className="modal-lg">
        <ModalHeader toggle={close}>
          {mode === "modal_add" ? "Add new" : "Update"} Site
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-8">
              <label className="required">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Site Name"
                value={this.state.name}
                onChange={e => this.setState({ name: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-4">
              <label className="required">Tag</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Site Tag"
                value={this.state.tag}
                onChange={e => this.setState({ tag: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-8">
              <label className="required">Description</label>
              <textarea
                rows="5"
                className="form-control"
                placeholder="Enter Location Description"
                value={this.state.description}
                onChange={e => this.setState({ description: e.target.value })}
              />
            </div>
            {!this.is_lite && (
            <div className="form-group col-sm-4" >
              <label className="required">Type</label>
              <SelectQuery
                placeholder="Enter Site Type"
                value={this.state.type}
                onChange={e => this.setState({ type: e.value })}
                urlKey="read-site-type-autocomplete"
                valKey="Alias"
                valLabel="Name"
                initOption={this.props.data.type}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
            )} 
            <div className="form-group col-sm-8">
              <label className="required">Address</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Site Address"
                value={this.state.address}
                onChange={e => this.setState({ address: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-4">
              {Module.SelectInMapButton(this.toggleModalSelectInMap)}
              <label className="required">Latitude</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Site Latitude"
                value={this.state.latitude}
                onChange={e => this.setState({ latitude: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-8">
              <label>Address 2</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Site Address2"
                value={this.state.address2}
                onChange={e => this.setState({ address2: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-4">
              <label className="required">Longitude</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Site Longitude"
                value={this.state.longitude}
                onChange={e => this.setState({ longitude: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-8">
              <label className="optional">GoogleMap URL</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter GoogleMap URL"
                value={this.state.gmaps_url}
                onChange={e => this.setState({ gmaps_url: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-4">
              <label className="required">City</label>
              <SelectQuery
                placeholder="Enter City"
                value={this.state.city}
                onChange={e => this.setState({ city: e.value })}
                urlKey="read-city-in-cov-autocomplete"
                valKey="pk"
                valLabel="Name"
                initOption={this.props.data.city}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-sm-8">
              <label className="optional">GoogleStreetview URL</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter GoogleStreetview URL"
                value={this.state.gstreet_url}
                onChange={e => this.setState({ gstreet_url: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-4">
              <label className="required">Postal Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Postal Code"
                value={this.state.postal_code}
                onChange={e => this.setState({ postal_code: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-8">
              <label className="required">Project Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Project Name"
                value={this.state.project_name}
                onChange={e => this.setState({ project_name: e.target.value })}
              />
            </div>
            {!this.is_lite && (
            <div className="form-group col-sm-4">
              <label className="required">Contact</label>
              <SelectQuery
                placeholder="Enter Contact"
                value={this.state.contact}
                onChange={e => this.setState({ contact: e.value })}
                urlKey="read-contact-autocomplete"
                valKey="Alias"
                valLabel="Name"
                initOption={this.props.data.contact}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
            )}
            <div className="form-group col-sm-12">
              <label className="required">Site Status</label>
              <SelectQuery
                placeholder="Enter Site Status"
                value={this.state.status}
                onChange={e => this.setState({ status: e.value })}
                urlKey="read-site-status-autocomplete"
                valKey="Alias"
                valLabel="Name"
                initOption={this.props.data.status}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
          </div>
          {this.renderLocationField()}
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={close}>cancel</ButtonCancel>
          <ButtonValidation
            is_process={this.state.is_process}
            onClick={this.modalAction}
          >
            {mode === "modal_add" ? "Save" : "Update"}
          </ButtonValidation>
        </ModalFooter>

        <ModalSelectInMap
          defaultLocation={{
            latitude: -43.52565,
            longitude: 172.639847
          }}
          onSave={this.getMapLocation.bind(this)}
          isOpen={this.state.modalMap}
          closeModal={this.toggleModalSelectInMap}
        />
      </Modal>
    );
  }
}

ModalSite.defaultProps = {is_lite : false}


// WEBPACK FOOTER //
// ./src/App/location/site/helper/component/Modal.js